// Account tab — thin delegation to AccountLayout.
//
// The old monolithic AccountTab was split into per-section components under
// pages/dashboard/account/. Layout (left rail on md+, top dropdown on mobile)
// and nested routing live in AccountLayout.
//
// Routes registered by AccountLayout:
//   /account/profile       — display name
//   /account/security      — change password
//   /account/ai-keys       — Anthropic + OpenAI provider keys + preferences
//   /account/prompts       — custom AI rewriter prompts (Pro+)
//   /account/integrations  — API keys + WordPress plugin download
//   /account/webhooks      — outbound webhooks (AutoPilot)
//   /account/notifications — weekly digest etc
//   /account/billing       — current plan + AutoPilot status + recent purchases
import AccountLayout from './account/AccountLayout';

export default function AccountTab() {
  return <AccountLayout />;
}
